import React from 'react';
import PropTypes from 'prop-types';

import { Badge } from '@mui/material';
import {Typography} from '@mui/material';
import Popover from '@mui/material/Popover';
import { lightGreen, yellow, orange } from '@mui/material/colors';
import {styled} from '@mui/system';

import JsonView from '../jsonLoader/json-loader';


const StyledBadgeText = styled(Typography)({
    paddingRight: 20,
    paddingBottom: 5
});

const StyledMatchDetails = styled('div')(({ theme }) =>({
    padding: 10,
    fontSize: theme.custom.font.small,
    maxWidth: 400
}));

const StyledMatchDetailsInfo = styled('div')({
    margin: '0 0 10px 0'
});

const StyledBaseMatchBadge = styled(Badge)(({ theme }) =>({
  "& .MuiBadge-badge": {
      color: theme.palette.text.primary,
      cursor: 'pointer'
  }
}));

const StyledDefaultMatchBadge = styled(StyledBaseMatchBadge)({
  "& .MuiBadge-badge": {
      backgroundColor: yellow[300],
  }
});

const StyledBadMatchBadge = styled(StyledBaseMatchBadge)({
  "& .MuiBadge-badge": {
      backgroundColor: orange[500],
  }
});

const StyledGoodMatchBadge = styled(StyledBaseMatchBadge)({
  "& .MuiBadge-badge": {
      backgroundColor: lightGreen['A700'],
  }
});


class BadgedTitle extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            anchorEl: null,
        };
    }

    handleClick = (event) => {
        if (this.props.match_details){
            this.setState({
                anchorEl: event.currentTarget,
            });
        }
    };

    handleClose = () => {
        this.setState({
            anchorEl: null,
        });
    };

    render() {
        let display_score = this.props.match_details ? this.props.match_details.display_score : 0;
        let BadgeComponent = display_score >= 100 ? StyledGoodMatchBadge : display_score < 0 ? StyledBadMatchBadge : StyledDefaultMatchBadge;
        let badge_display_score = display_score === 0 ? display_score : display_score <= 1000 ? display_score.toString() : '>1000';
        return (
            <span>
                <BadgeComponent
                       badgeContent={badge_display_score} max={1000} onClick={this.handleClick} color="primary">
                    <StyledBadgeText variant="subtitle2">
                        {this.props.title}</StyledBadgeText>
                </BadgeComponent>
                <Popover
                     id="info_popover"
                     open={this.state.anchorEl !== null}
                     anchorEl={this.state.anchorEl}
                     onClose={this.handleClose}
                     anchorOrigin={{
                         vertical: 'bottom',
                         horizontal: 'center',
                     }}
                     transformOrigin={{
                         vertical: 'top',
                         horizontal: 'center',
                     }}
                 >
                     {this.props.match_details && <StyledMatchDetails>
                         <StyledMatchDetailsInfo>
                             {this.props.match_details.match_explanation.map((item, index) =>
                                 <p key={index}>{item}</p>
                             )}
                         </StyledMatchDetailsInfo>
                         <JsonView src={this.props.match_details.match_details_info} />
                     </StyledMatchDetails>}
                </Popover>
            </span>
        );
    }
}

BadgedTitle.propTypes = {
    title: PropTypes.string.isRequired,
    match_details: PropTypes.object
};

export default BadgedTitle;
